import { useCallback, useState } from "react";

export type FlashType = "success" | "error" | "info" | "warning";

export function useFlashMessage(timeoutMs = 5000) {
  const [message, setMessage] = useState<string | null>(null);
  const [type, setType] = useState<FlashType>("info");

  const showMessage = useCallback(
    (msg: string, t: FlashType = "info") => {
      setMessage(msg);
      setType(t);
      if (timeoutMs > 0) {
        setTimeout(() => setMessage(null), timeoutMs);
      }
    },
    [timeoutMs]
  );

  const clearMessage = useCallback(() => setMessage(null), []);

  return { message, type, showMessage, clearMessage };
}
